import React from 'react';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

export default ({ iconProps, ...restProps }) => (
  <IconButton {...restProps} aria-label="close">
    <CloseIcon {...iconProps} />
  </IconButton>
);
